import React from 'react';
import { Select } from 'antd';
import { taxCodes } from 'constants/taxCodes';

const SelectCstPisCofins = ({ valueType = 'int', showNoneOption = false, ...rest }) => {
  const format = (code) =>
    valueType === 'string' ? String(code).padStart(2, '0') : code;

  return (
    <Select {...rest} dropdownMatchSelectWidth={450}>
      {showNoneOption && (
        <Select.Option value={format(0)}>00 – Nenhum</Select.Option>
      )}
      {taxCodes.cstPisCofins.map(({ code, title }) => (
        <Select.Option key={code} value={format(code)}>{title}</Select.Option>
      ))}
    </Select>
  )
}

export default SelectCstPisCofins;
